module.exports = __webpack_public_path__ + "static/media/Alert Circle.577dd716.svg";